// extracted by mini-css-extract-plugin
export var dropdownContainer = "_o4-0";
export var leftAlign = "_o4-4";
export var listItem = "_o4-2";
export var listItemWrapper = "_o4-1";
export var operationText = "_o4-3";